import { Headline } from '@oneaudi/unified-web-components';
import { UeElement } from '@oneaudi/falcon-tools';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import React from 'react';
import type { HeadlineProps } from '../../EditorContentTypes';

// eslint-disable-next-line react/display-name
const Headliner: React.FC<HeadlineProps> = React.memo(
  ({ text, hierarchy, property }: HeadlineProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!text?.length) return null;

    return (
      <UeElement type="text" property={property} label="Headline">
        <Headline
          tag={hierarchy}
          variant={{
            order: '2',
            type: 'headline',
            weight: 'normal',
          }}
          margin={[0, 0, 'var(--spacing-relative-xl)', 0]}
          data-testid="headline"
        >
          {renderTextWithFootnotesReferencesV2(text)}
        </Headline>
      </UeElement>
    );
  },
);

export default Headliner;
